import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { breakpoints } from '../helpers/constants';
gsap.registerPlugin(ScrollTrigger);
export const snapToFrame = $el => {
  const mm = gsap.matchMedia();
  mm.add(`(min-width: ${breakpoints.xl}px)`, () => {
    ScrollTrigger.create({
      trigger: $el,
      start: 'top center',
      end: 'bottom center',
      snap: {
        snapTo: $el.offsetHeight <= window.outerHeight ? [0.5] : '.test',
        duration: {
          min: 0.5,
          max: 1
        },
        delay: 0.2
      }
    });
  });
};
const animate = $el => {
  const mm = gsap.matchMedia();
  const $appLinks = $el.querySelectorAll('.application-link');
  snapToFrame($el);
  gsap.from($el, {
    opacity: 0,
    scrollTrigger: {
      trigger: $el,
      end: 'bottom bottom',
      scrub: true
    }
  });
  mm.add(`(min-width: ${breakpoints.xl}px)`, () => {
    gsap.from($appLinks, {
      yPercent: 100,
      scrollTrigger: {
        trigger: $el,
        scrub: true
      }
    });
  });
};
const init = () => {
  const $application = document.querySelectorAll('.application');
  const $galleryItems = document.querySelectorAll('.gallery-item');
  [...$application].forEach(e => {
    animate(e);
  });
  [...$galleryItems].forEach($el => {
    ScrollTrigger.create({
      trigger: $el,
      start: 'center bottom',
      onEnter: () => $el.classList.add('visible')
    });
  });
};
export default init;